import styled, { css } from 'styled-components';
import { Palette } from 'config';

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const ErrorWrapper = styled.span`
  display: inline-flex;
  align-items: center;
  margin-top: 8px;
  img,
  svg {
    height: 16px;
    min-width: 16px;
    max-width: 16px;
  }
`;

export const ErrorText = styled.span`
  color: ${() => Palette.Red._700};
  font-weight: normal;
  font-size: 12px;
  line-height: 16px;
  margin-left: 8px;
`;

export const RemoveButton = styled.button`
  width: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  svg {
    fill: ${Palette.PrimaryGray._400};
    &:active {
      fill: ${() => Palette.Primary._400};
    }
  }
`;

export const FileItem = styled.div`
  height: 32px;
  padding-left: 8px;
  background: white;
  width: 100%;
  border-radius: 4px;
  border: 1px solid ${Palette.PrimaryGray._200};
  box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.05);
  display: flex;
  justify-content: space-between;
  span {
    min-width: 94%;
    font-size: 12px;
    line-height: 32px;
    color: ${Palette.PrimaryGray._700};
  }
`;

export const SelectedFileWrapper = styled.div`
  padding: 16px;
  width: 100%;
  height: 64px;
  border-radius: 4px;
  background: ${Palette.PrimaryGray._000};
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.04) inset;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const FileUploaderWrapper = styled.div`
  padding-left: 16px;
  width: 770px;
  height: 50px;
  border-radius: 4px;
  background: ${Palette.PrimaryGray._000};
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.04) inset;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: row;
  span {
    margin-left: 8px;
    font-size: 12px;
    color: ${Palette.PrimaryGray._500};
    line-height: 16px;
    text-transform: none;
  }
  ${({ error }) =>
    error &&
    css`
      background: ${() => Palette.PrimaryGray._000};
      border: 1px solid ${() => Palette.Red._300};
    `}
  ${({ isDragging }) =>
    isDragging &&
    css`
      border-radius: 4px;
      border: 1px dashed var(--primary-300, #91c7fd);
      background: var(--primary-gray-100, #f1f5f9);
      box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.04) inset;
    `};
  button {
    opacity: ${({ isDragging }) => isDragging && 0.5};
  }
  border: 1px solid ${() => Palette.PrimaryGray._200};
  &:hover {
    border: 1px solid ${() => Palette.PrimaryGray._300};
  }
  transition: border-color 0.3s;
`;

export const FileInput = styled.input`
  display: none;
`;

export const ItemsContainer = styled.div`
  flex-grow: 1;
  overflow-y: auto;
  height: 400px;
  padding: 24px;
  background: ${Palette.PrimaryGray._000};
  ::-webkit-scrollbar {
    width: 6px;
    background-color: ${Palette.PrimaryGray._000};
  }

  ::-webkit-scrollbar-thumb {
    background-color: #cbd5e1;
    border-radius: 8px;
  }
`;
